import useTranslation from 'next-translate/useTranslation'
import { TermsOfSale, TermsOfUse } from '@components/terms'
import { PolicySectionBorder, PolicySectionTitle } from '@components/privacy'

interface TermsProps {
  termsOfSalesContent: string
  termsOfUseContent: string
}

export const TermsComponent = ({
  termsOfUseContent,
  termsOfSalesContent,
}: TermsProps) => {
  const { t } = useTranslation()

  return (
    <div className="max-w-content-xl sm:mx-content-margin-desktop 2lg:relative 2xl:mx-auto flex flex-col">
      <h1 className="text-4xl font-archivo font-black text-blue ml-4 sm:ml-0 mr-auto">
        {t('terms:terms_title')}
      </h1>

      <div className="flex flex-col mx-4 sm:ml-0 mt-10 lg:mt-28 lg:ml-80 lg:mr-0 pb-32">
        <PolicySectionTitle>Summary</PolicySectionTitle>
        <ol className="list-decimal list-inside">
          <li className="mb-2 hover:text-blue">
            <a href="#terms-of-use">Terms of use of the website</a>
          </li>
          <li className="mb-2 hover:text-blue">
            <a href="#terms-of-sale">General terms and conditions of sale</a>
          </li>
        </ol>
        <PolicySectionBorder />
        <TermsOfUse content={termsOfUseContent} />
        <TermsOfSale content={termsOfSalesContent} />
      </div>
    </div>
  )
}
